import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { InfoCircle } from "react-bootstrap-icons";

const InfoTooltip = ({ text }) => {
  return (
    <OverlayTrigger
      placement="top" // Tooltip appears on top
      overlay={
        <Tooltip id="tooltip">
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </Tooltip>
      }
    >
      <span className="ms-2 text-primary" style={{ cursor: "pointer" }}>
        <InfoCircle size={16} />
      </span>
    </OverlayTrigger>
  );
};

export default InfoTooltip;
